const createProgram = ({
  name,
  location,
  type,
  sourceUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  mapEmbedUrl,
}) => ({
  name,
  location,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions and requirements', admissions],
  ],
  paragraphs: [
    focus,
    'Program length, tuition, prerequisites, clinical requirements, application deadlines, accreditation, and cohort availability can change. Confirm all current details directly with the institution before applying.',
  ],
  highlights,
  address: location,
  mapEmbedUrl,
});

export const programs = [
  createProgram({
    name: 'Herzing University - Tampa, Physical Therapist Assistant Program',
    location: '5703 Ulmerton Road, Clearwater, FL 33760',
    type: 'Private university PTA degree program',
    sourceUrl: 'https://www.herzing.edu/physical-therapist-assistant',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Herzing+University+Tampa+Physical+Therapist+Assistant&output=embed',
    overview:
      'Herzing University’s Tampa campus offers an Associate of Science in Physical Therapist Assistant designed for students preparing for hands-on rehabilitation careers.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'On-campus laboratory instruction, general education with online components, and mandatory clinical rotations',
    length: 'Approximately 20 months',
    tuition:
      'Estimated total tuition and fees are approximately $33,000 to $36,000. Financial aid, military benefits, and institutional scholarships may be available to qualified applicants.',
    admissions:
      'Applicants generally need a high school diploma or GED and must complete required background checks, drug screening, healthcare immunizations, and other clinical compliance requirements.',
    focus:
      'The program is CAPTE accredited and prepares graduates to sit for the National Physical Therapy Examination for physical therapist assistants. Confirm current accreditation and licensure details directly with Herzing University.',
    highlights: [
      'Tampa-area private university PTA pathway',
      'Associate of Science degree',
      'Approximately 20-month completion timeline',
      'On-campus labs and required clinical rotations',
      'Estimated tuition and fees of approximately $33,000 to $36,000',
    ],
  }),
  createProgram({
    name: 'South University - Tampa, Physical Therapist Assistant Program',
    location: '4404 North Himes Avenue, Tampa, FL 33614',
    type: 'Private university PTA degree program',
    sourceUrl:
      'https://www.southuniversity.edu/areas-of-study/health-sciences/physical-therapist-assistant',
    mapEmbedUrl:
      'https://www.google.com/maps?q=South+University+Tampa+Physical+Therapist+Assistant&output=embed',
    overview:
      'South University’s Tampa campus offers an Associate of Science in Physical Therapist Assistant with classroom, online, laboratory, and clinical education components.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Hybrid didactic instruction, practical laboratory sessions, and full-time clinical externships',
    length: 'Approximately 2 years across 5 academic semesters',
    tuition:
      'Estimated program tuition is approximately $38,000 to $42,000, excluding additional costs such as books, uniforms, background screening, and board examination fees.',
    admissions:
      'Applicants must meet general education prerequisite standards, satisfy minimum GPA expectations, complete admissions assessments, and meet clinical compliance requirements.',
    focus:
      'The program is CAPTE accredited and prepares students for eligibility to take the NPTE-PTA licensure examination. Verify current program and accreditation information with South University.',
    highlights: [
      'Tampa private university PTA program',
      'Five-semester full-time curriculum',
      'Hybrid classroom and online instruction',
      'Laboratory training and regional clinical externships',
      'Estimated tuition of approximately $38,000 to $42,000',
    ],
  }),
  createProgram({
    name: 'St. Petersburg College, Physical Therapist Assistant Program',
    location: '6021 142nd Avenue North, Clearwater, FL 33760',
    type: 'Public state college PTA degree program',
    sourceUrl:
      'https://www.spcollege.edu/friends-partners/about/academic-programs/health-sciences-and-veterinary-technology/physical-therapist-assistant-as-degree',
    mapEmbedUrl:
      'https://www.google.com/maps?q=St.+Petersburg+College+Physical+Therapist+Assistant&output=embed',
    overview:
      'St. Petersburg College offers an Associate of Science in Physical Therapist Assistant with prerequisite coursework, a technical core, and local clinical education.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Classroom instruction, online learning support, laboratory practice, and local clinical rotations',
    length: 'Approximately 2 years, including a 5-semester technical core',
    tuition:
      'Estimated total tuition is approximately $7,100 for Florida residents and $24,500 for out-of-state students, excluding books, clinical fees, uniforms, and other program expenses.',
    admissions:
      'Admission is selective and point-based. Applicants generally need prerequisite Anatomy and Physiology coursework with a C or better, a minimum GPA, and a passing score on the HESI health occupations assessment.',
    focus:
      'The program is CAPTE accredited. Confirm current admission points, prerequisites, tuition, clinical requirements, and accreditation status with St. Petersburg College.',
    highlights: [
      'Public Florida state college PTA pathway',
      'Associate of Science degree',
      'Selective, point-based admission',
      'Five-semester technical core',
      'Estimated Florida-resident tuition of approximately $7,100',
    ],
  }),
  createProgram({
    name: 'State College of Florida, Manatee-Sarasota, Physical Therapist Assistant Program',
    location: '5840 26th Street West, Bradenton, FL 34207',
    type: 'Public state college PTA degree program',
    sourceUrl:
      'https://www.scf.edu/academics/degrees-certificates/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=State+College+of+Florida+Manatee+Sarasota+Physical+Therapist+Assistant&output=embed',
    overview:
      'State College of Florida, Manatee-Sarasota offers an Associate of Science physical therapist assistant pathway with classroom, digital, laboratory, and supervised clinical education.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Classroom instruction, digital learning modules, laboratory practice, and supervised clinical practice',
    length: 'Approximately 2 years in a structured cohort',
    tuition:
      'Florida-resident tuition is approximately $105 per credit hour, with estimated total program tuition of approximately $7,500 to $8,500 before technical lab fees, books, and clinical equipment.',
    admissions:
      'Admission is competitive and limited-access. Requirements may include college-level math, Anatomy and Physiology, a minimum GPA, health screenings, and other clinical compliance documents.',
    focus:
      'The program is CAPTE accredited and prepares graduates for licensure through the NPTE-PTA. Confirm current program requirements and accreditation information with the college.',
    highlights: [
      'Public Manatee-Sarasota state college program',
      'Structured 2-year cohort timeline',
      'Approximately $105 per credit hour for Florida residents',
      'Estimated tuition of approximately $7,500 to $8,500',
      'Competitive, limited-access admission',
    ],
  }),
  createProgram({
    name: 'Polk State College, Physical Therapist Assistant Program',
    location: '999 Avenue H Northeast, Winter Haven, FL 33881',
    type: 'Public state college PTA degree program',
    sourceUrl:
      'https://www.polk.edu/health-sciences/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Polk+State+College+Physical+Therapist+Assistant&output=embed',
    overview:
      'Polk State College offers an Associate of Science in Physical Therapist Assistant with classroom instruction, online learning tools, laboratory training, and clinical education.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Face-to-face instruction, online learning support, hands-on laboratory training, and clinical education',
    length: 'Approximately 2 years of full-time enrollment',
    tuition:
      'Florida-resident tuition is approximately $115 per credit hour, with estimated total program tuition of around $8,500 plus approximately $2,000 for specialized course fees, textbooks, and clinical supplies.',
    admissions:
      'Entry is selective and point-based. Applicants may need prerequisite coursework, minimum GPA results, observation hours, health documentation, and other clinical compliance verifications.',
    focus:
      'The program is CAPTE accredited. Confirm current prerequisites, admission points, tuition, clinical placements, and accreditation status with Polk State College.',
    highlights: [
      'Public Florida state college PTA pathway',
      'Approximately 2-year full-time program',
      'Estimated Florida-resident tuition of approximately $8,500',
      'Approximately $2,000 in additional program expenses',
      'Selective, point-based admissions process',
    ],
  }),
  createProgram({
    name: 'College of Central Florida, Physical Therapist Assistant Program',
    location: '3001 Southwest College Road, Ocala, FL 34474',
    type: 'Public state college PTA degree program',
    sourceUrl:
      'https://www.cf.edu/academics/programs/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=College+of+Central+Florida+Physical+Therapist+Assistant&output=embed',
    overview:
      'The College of Central Florida offers an Associate of Science in Physical Therapist Assistant with science prerequisites, technical coursework, laboratory training, and clinical placements.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'On-campus lectures, digital learning resources, hands-on laboratories, and clinical practice placements',
    length: 'Approximately 2 years',
    tuition:
      'Estimated in-state tuition is approximately $3,100 per year, or approximately $6,500 to $7,500 for the full program, excluding books, clinical supplies, background checks, and other program fees.',
    admissions:
      'Admission is selective and point-driven. Applicants should expect prerequisite science coursework, minimum GPA requirements, background clearance, and clinical compliance requirements.',
    focus:
      'The program is CAPTE accredited and prepares graduates for state licensure examinations. Confirm current requirements and accreditation status with the College of Central Florida.',
    highlights: [
      'Public Florida state college PTA degree',
      'Approximately 2-year technical curriculum',
      'Estimated in-state tuition of approximately $6,500 to $7,500 total',
      'Hands-on laboratory and clinical training',
      'Selective, point-driven admission',
    ],
  }),
  createProgram({
    name: 'College of Central Florida, Certified Physical Therapy Aide Program',
    location: '3001 Southwest College Road, Ocala, FL 34474',
    type: 'Online physical therapy aide certificate program',
    sourceUrl:
      'https://www.cf.edu/academics/ce/healthcare/physical-therapy-aide/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=College+of+Central+Florida+Ocala+Campus&output=embed',
    overview:
      'The College of Central Florida offers a self-paced online Certified Physical Therapy Aide program covering foundational clinical support and healthcare administration topics.',
    credential: 'Certified Physical Therapy Aide certificate',
    format: 'Fully online, self-paced instruction',
    length: '202 course hours, with up to 9 months for completion',
    tuition:
      'Total tuition is approximately $3,012, with flexible payment options such as Affirm and TuitionFlex. Tuition includes digital and shipped textbooks and an exam voucher.',
    admissions:
      'No formal healthcare prerequisites are generally required beyond a high school diploma or equivalent. Confirm current enrollment requirements with the college.',
    focus:
      'This is an aide certificate program, not a physical therapist assistant degree. CAPTE accreditation does not apply because CAPTE accredits physical therapist and physical therapist assistant degree programs.',
    highlights: [
      'Self-paced online aide training',
      '202 course hours with up to 9 months to complete',
      'Approximately $3,012 total tuition',
      'Includes textbooks and an AMCA PTTC exam voucher',
      'No CAPTE accreditation because this is an aide certificate',
    ],
  }),
  createProgram({
    name: 'Lake-Sumter State College, Certified Physical Therapy Aide Program',
    location: '9501 U.S. Highway 441, Leesburg, FL 34788',
    type: 'Online physical therapy aide certificate program',
    sourceUrl: 'https://www.lssc.edu/programs/continuing-education/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Lake-Sumter+State+College+Leesburg+FL&output=embed',
    overview:
      'Lake-Sumter State College provides a self-paced online Certified Physical Therapy Aide training program for students seeking entry-level clinical support preparation.',
    credential: 'Certified Physical Therapy Aide certificate',
    format: 'Fully online, self-paced instruction',
    length: '202 course hours, with up to 9 months of access',
    tuition:
      'Program tuition is approximately $2,599, with flexible installment options available through Affirm. Confirm the current price and included materials before registering.',
    admissions:
      'No prior healthcare experience or college prerequisites are generally required. Confirm the current enrollment and eligibility requirements with Lake-Sumter State College.',
    focus:
      'The program covers medical terminology, body mechanics, patient positioning, and therapeutic exercises. CAPTE accreditation does not apply to this aide training course.',
    highlights: [
      'Self-paced online certificate program',
      '202 course hours over a maximum 9-month access period',
      'Approximately $2,599 tuition',
      'Includes an AMCA PTTC exam voucher',
      'No CAPTE accreditation because this is an aide course',
    ],
  }),
  createProgram({
    name: 'American Allied Health, Certified Physical Therapy Aide (CPTA) Certification',
    location: 'Online certification program',
    type: 'Online professional aide certification',
    sourceUrl:
      'https://www.americanalliedhealth.com/physical-therapy-aide-certification',
    mapEmbedUrl:
      'https://www.google.com/maps?q=American+Allied+Health+Physical+Therapy+Aide+Certification&output=embed',
    overview:
      'American Allied Health offers a competency-based Certified Physical Therapy Aide certification pathway for candidates completing preparatory training or documenting relevant work experience.',
    credential: 'Certified Physical Therapy Aide (CPTA)',
    format: 'Online, self-paced examination process',
    length: 'Self-paced; candidates test after meeting eligibility requirements',
    tuition:
      'The independent national examination fee is typically approximately $100 to $150. Confirm current fees directly with American Allied Health.',
    admissions:
      'Eligibility generally includes a high school diploma or equivalent and either completion of a training program or documented on-the-job work experience.',
    focus:
      'This is a professional certification rather than an academic physical therapist assistant degree. CAPTE accreditation does not apply to the certification examination.',
    highlights: [
      'National online aide certification pathway',
      'Self-paced examination format',
      'Typical examination fee of approximately $100 to $150',
      'High school diploma or equivalent generally required',
      'CAPTE accreditation does not apply',
    ],
  }),
  createProgram({
    name: 'University of Florida, Certified Physical Therapy Aide Program',
    location: 'Online program offered through the University of Florida',
    type: 'Online physical therapy aide certificate program',
    sourceUrl: 'https://ce.ufl.edu/healthcare/physical-therapy-aide/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=University+of+Florida+Gainesville+FL&output=embed',
    overview:
      'The University of Florida offers an online Certified Physical Therapy Aide training program covering documentation, anatomy, therapeutic modalities, and patient mobility.',
    credential: 'Certified Physical Therapy Aide certificate',
    format: 'Fully online, self-paced instruction',
    length: '202 course hours, with a 9-month completion window',
    tuition:
      'Tuition is approximately $2,599, with financing options such as Affirm and TuitionFlex. Enrollment includes required textbooks and an exam voucher.',
    admissions:
      'The program is designed to be accessible without strict academic prerequisites. Confirm current enrollment requirements and course availability with the University of Florida.',
    focus:
      'This is vocational aide training rather than a professional physical therapist assistant degree. CAPTE accreditation does not apply, and graduates should confirm employer expectations for entry-level roles.',
    highlights: [
      'University of Florida online aide training',
      '202 course hours over 9 months',
      'Approximately $2,599 tuition',
      'Includes e-books, shipped textbooks, and an AMCA PTTC exam voucher',
      'No CAPTE accreditation because this is vocational aide training',
    ],
  }),
];

export const resources = [
  {
    title: 'American Physical Therapy Association',
    description:
      'Explore physical therapy education, professional standards, advocacy, and career resources.',
    url: 'https://www.apta.org/',
  },
  {
    title: 'Federation of State Boards of Physical Therapy',
    description:
      'Review physical therapist assistant licensure and National Physical Therapy Examination resources.',
    url: 'https://www.fsbpt.org/',
  },
  {
    title: 'Florida Board of Physical Therapy',
    description:
      'Find Florida licensing, renewal, rules, and practice information for physical therapist assistants.',
    url: 'https://floridasphysicaltherapy.gov/',
  },
];